export const iconFontAwesomeUsersPeopleFaceFrown = (
	<i className="fa-solid fa-face-frown"></i>
);
